/*
 * 2026 WilderdijkDynamics.
 * SIMGASM 4.92. Collection/list/featured and hotspot sold-out alternatives.
 * Delegated events preserve Empire filtering, pagination and the native cart events.
 */
(() => {
  'use strict';
  if (window.__wdCollectionSimilar485) return;
  window.__wdCollectionSimilar485 = true;

  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-wd-r85-close]');
    if (close) {
      const dialog = close.closest('[data-wd-r85-dialog]');
      if (dialog?.open) dialog.close();
      return;
    }
    const open = event.target.closest('[data-wd-r85-open]');
    if (!open) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const card = open.closest('[data-wd-r19-card], [data-wd-hotspot-panel]');
    const dialog = card?.querySelector('[data-wd-r85-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return; // href still works without JS/dialog support.
    const productId = String(open.dataset.wdR85ProductId || dialog.dataset.wdR85OriginalId || '');
    if (!/^\d+$/.test(productId)) return;
    event.preventDefault();
    if (!dialog.open) dialog.showModal();
    const results = dialog.querySelector('[data-wd-r85-results]');
    if (!results) return;
    const originalId = String(dialog.dataset.wdR85OriginalId);
    const manual = dialog.querySelector('[data-wd-r85-manual-template]');
    if (productId === originalId && manual) {
      results.replaceChildren(manual.content.cloneNode(true));
      dialog.dataset.wdR85ShownId = productId;
      return;
    }
    if (dialog.dataset.wdR85ShownId === productId) return;
    dialog.dataset.wdR85ShownId = productId;
    results.replaceChildren();
    const loading = document.createElement('p');
    loading.textContent = 'Loading similar products...';
    results.append(loading);
    try {
      const url = new URL(dialog.dataset.wdR85RecommendationsUrl, document.baseURI);
      url.searchParams.set('section_id', 'wd-similar-products');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '8');
      url.searchParams.set('intent', 'related');
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const html = await response.text();
      if (!dialog.isConnected || dialog.dataset.wdR85ShownId !== productId) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const section = parsed.querySelector('[data-wd-similar-results]');
      if (!section) throw new Error('No recommendations section');
      results.replaceChildren(...Array.from(section.childNodes).map(node => document.importNode(node, true)));
    } catch (_) {
      if (!dialog.isConnected || dialog.dataset.wdR85ShownId !== productId) return;
      const message = document.createElement('p');
      message.textContent = 'Similar products are unavailable right now.';
      const fallback = document.createElement('a');
      fallback.className = 'wd-avail__browseLink';
      fallback.href = open.href;
      fallback.textContent = 'View product details';
      results.replaceChildren(message, fallback);
    }
  });

  document.addEventListener('click', event => {
    if (event.target.matches('[data-wd-r85-dialog]') && event.target.open) event.target.close();
  });
})();
